import { useTranslation } from "react-i18next";
import PageBreadcrumb from "../../../../shared/ui/common/PageBreadCrumb";
import PageMeta from "../../../../shared/ui/common/PageMeta";
import CouplePatientAddForm from "../components/AddForm/CouplePatientAddForm";
import { useTherapist } from "../../../../context/TherapistProvider";

export default function AddCouplePatient() {
    const { t } = useTranslation();
    const { therapist } = useTherapist();

    return (
        <div>
            <PageMeta title={t("patient.newCouple")} />
            <PageBreadcrumb pageTitle={t("patient.newCouple")} />
            <div className="flex justify-center w-full pt-8 pb-12">
                <div className="w-full max-w-xl">
                    <CouplePatientAddForm therapistID={therapist?.id ?? ""} />
                </div>
            </div>
        </div>
    );
}
